import { logger } from './logger';
/*
    Create a task that will repeat every 'intervalMs'.
 */
export class RepeatingTask {
    constructor(config) {
        this.stopped = true;
        this.errorThreshold = 1;
        this.errorCount = 0;
        this.task = config.task;
        this.taskName = config.taskName;
        this.intervalMs = config.intervalMs;
        this.errorThreshold = config.errorThreshold || this.errorThreshold;
        this.onError = config.onError;
        logger.info(`Created new RepeatingTask taskName=${this.taskName} with intervalMs=${this.intervalMs} errorThreshold=${this.errorThreshold}`);
    }
    async start() {
        if (!this.stopped) {
            logger.info(`RepeatingTask taskName=${this.taskName} already started. interval=${this.interval}`);
            return;
        }
        this.stopped = false;
        await this.executeTask();
        this.interval = window.setInterval(async () => await this.executeTask(), this.intervalMs);
        logger.info(`RepeatingTask taskName=${this.taskName} started. interval=${this.interval}`);
    }
    stop() {
        clearInterval(this.interval);
        this.stopped = true;
        logger.info(`RepeatingTask taskName=${this.taskName} is stopped`);
    }
    async executeTask() {
        if (this.stopped) {
            this.stop();
        }
        try {
            await this.task();
        }
        catch (e) {
            logger.error(`RepeatingTask taskName=${this.taskName} errorCount=${this.errorCount} of errorThreshold=${this.errorThreshold} has failed with exception=${e}`);
            if (this.errorCount >= this.errorThreshold) {
                logger.error(`RepeatingTask taskName=${this.taskName} errorCount=${this.errorCount} has exceeded errorThreshold=${this.errorThreshold} with exception=${e}.  Stopping Task.`);
                this.stop();
                this.onError(e);
            }
        }
    }
}
//# sourceMappingURL=repeating_task.js.map